import { render, staticRenderFns } from "./footballCup_common.vue?vue&type=template&id=7a2d61e0"
import script from "./footballCup_common.vue?vue&type=script&lang=js"
export * from "./footballCup_common.vue?vue&type=script&lang=js"
import style0 from "./footballCup_common.vue?vue&type=style&index=0&id=7a2d61e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports